import { render, staticRenderFns } from "./AdminRoles.vue?vue&type=template&id=67f7979e&scoped=true"
import script from "./AdminRoles.vue?vue&type=script&lang=ts"
export * from "./AdminRoles.vue?vue&type=script&lang=ts"
import style0 from "./AdminRoles.vue?vue&type=style&index=0&id=67f7979e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f7979e",
  null
  
)

export default component.exports